export function ServiceGroupItemCap(parentEl) {
    var _a, _b;
    if (!parentEl) {
        return;
    }
    var children = parentEl.querySelectorAll('.service-group-item');
    if (!children || children && children.length < 1) {
        return;
    }
    var config = {
        viewingAllItems: false,
        classNames: {
            hidden: 'item-hidden'
        },
        texts: {
            viewAll: 'Visa alla',
            hideSome: 'Dölj'
        }
    };
    var viewMoreButton = document.createElement('a');
    (_a = viewMoreButton.classList).add.apply(_a, ['empori-button', 'p-c-bgc', 'inverted']);
    viewMoreButton.innerText = config.texts.viewAll;
    function hideItems() {
        children.forEach(function (item, index) {
            if (index >= 6) {
                item.classList.add(config.classNames.hidden);
                viewMoreButton.innerText = config.texts.viewAll;
            }
        });
        config.viewingAllItems = false;
    }
    function showItems() {
        children.forEach(function (item) {
            item.classList.remove(config.classNames.hidden);
            viewMoreButton.innerText = config.texts.hideSome;
        });
        config.viewingAllItems = true;
    }
    if (children.length > 6) {
        hideItems();
        var viewMoreContainer = document.createElement('div');
        (_b = viewMoreContainer.classList).add.apply(_b, ['empori-buttons-container', 'align-center']);
        viewMoreButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (!config.viewingAllItems) {
                showItems();
                return;
            }
            hideItems();
        });
        viewMoreContainer.appendChild(viewMoreButton);
        parentEl.appendChild(viewMoreContainer);
    }
}
